/* PDP add-to-cart: stay on the page, open the cart drawer.
   Product forms (Minimog + EComposer) POST natively to /cart/add, which
   navigates the shopper away to /cart. Intercept those submits, add via
   AJAX instead, and open the drawer they added from.
   Skips: dynamic/accelerated checkout buttons, forms without a variant id,
   pages where the drawer is disabled or absent (falls back to native). */
(function () {
  function drawerEl() {
    return document.querySelector('m-cart-drawer');
  }

  function drawerEnabled() {
    try {
      if (window.MinimogSettings && window.MinimogSettings.enable_cart_drawer === false) return false;
    } catch (e) {}
    return !!drawerEl();
  }

  function atcButton(form, submitter) {
    if (submitter && submitter.getAttribute && submitter.getAttribute('name') === 'add') return submitter;
    return form.querySelector('[name="add"]');
  }

  function setLoading(btn, on) {
    if (!btn) return;
    if (on) {
      btn.disabled = true;
      btn.classList.add('m-spinner-loading');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.disabled = false;
      btn.classList.remove('m-spinner-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  function showError(form, message) {
    try {
      var host = form.querySelector('.m-product-form-message');
      var node = document.createElement('div');
      node.setAttribute('data-skoon-atc-error', 'true');
      node.textContent = message || 'Could not add to cart. Please try again.';
      node.style.cssText = 'color:#b00020;font-size:13px;margin-top:8px;';
      if (host) {
        host.innerHTML = '';
        host.appendChild(node);
      } else {
        var btn = form.querySelector('[name="add"]');
        if (btn && btn.parentElement) btn.parentElement.appendChild(node);
      }
      window.setTimeout(function () {
        if (node.parentElement) node.parentElement.removeChild(node);
      }, 5000);
    } catch (e) {}
  }

  function clearError(form) {
    try {
      var host = form.querySelector('.m-product-form-message');
      if (host) host.innerHTML = '';
      var stale = form.querySelector('[data-skoon-atc-error]');
      if (stale && stale.parentElement) stale.parentElement.removeChild(stale);
    } catch (e) {}
  }

  function buildItem(form) {
    var idInput = form.querySelector('[name="id"]');
    var id = idInput && parseInt(idInput.value, 10);
    if (!id) return null;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var item = { id: id, quantity: Math.max(1, qty) };
    // Pass through line properties (gift card recipient etc.).
    try {
      var data = new FormData(form);
      var props = {};
      var sellingPlan = '';
      data.forEach(function (value, key) {
        if (key.indexOf('properties[') === 0) props[key.slice(11, -1)] = String(value);
        else if (key === 'selling_plan') sellingPlan = String(value);
      });
      if (Object.keys(props).length) item.properties = props;
      if (sellingPlan) item.selling_plan = sellingPlan;
    } catch (e) {}
    return item;
  }

  function openDrawer(resp) {
    var d = drawerEl();
    if (!d) return false;
    try {
      if (resp && resp.sections && typeof d.renderContents === 'function') {
        d.renderContents(resp);
        return true;
      }
      if (typeof d.open === 'function') {
        d.open();
        return true;
      }
    } catch (e) {}
    return false;
  }

  function emitCartUpdate(resp) {
    try {
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, resp || {});
      }
    } catch (e) {}
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    var submitter = e.submitter || null;
    // Never touch accelerated/dynamic checkout.
    if (submitter && submitter.closest &&
        submitter.closest('.shopify-payment-button, .m-product-dynamic-checkout, [data-shop-pay], .shopify-cleanslate')) {
      return;
    }
    // Only handle the regular Add to cart button.
    if (submitter && submitter.getAttribute && submitter.getAttribute('name') !== 'add' &&
        submitter.type !== 'submit') {
      return;
    }
    if (submitter && submitter.getAttribute && submitter.getAttribute('name') !== 'add' &&
        submitter.type === 'submit' && !form.querySelector('[name="add"]')) {
      return;
    }

    var item = buildItem(form);
    if (!item) return; // no variant resolved: let native behaviour run
    if (!drawerEnabled()) return; // no drawer (or disabled): native → cart page

    e.preventDefault();
    clearError(form);
    var btn = atcButton(form, submitter);
    setLoading(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (data) { throw data; }).catch(function () { throw { description: 'Could not add to cart.' }; });
      return res.json();
    }).then(function (resp) {
      setLoading(btn, false);
      emitCartUpdate(resp);
      if (!openDrawer(resp)) {
        // Drawer failed to render: fall back to the cart page.
        window.location.href = '/cart';
      }
    }).catch(function (err) {
      setLoading(btn, false);
      // If the add itself is uncertain (network), fall back to native submit
      // so the shopper never loses the item.
      if (!err || !err.description) {
        try { form.submit(); } catch (submitErr) { showError(form); }
        return;
      }
      showError(form, err.description);
    });
  });
})();
